import { httpClient } from "common/HttpClient/http-client";

const CONTEXT_IMPORT_BASE = "/platform-admin-service/v1/imports/context-nodes";
const CONTEXT_IMPORT_JOBS_BASE = "/platform-admin-service/v1/jobs";

export function buildContextImportPath(mode) {
  const params = new URLSearchParams({ mode });
  return `${CONTEXT_IMPORT_BASE}?${params.toString()}`;
}

export const CONTEXT_IMPORT_VALIDATE_PATH = buildContextImportPath("validate");

export const CONTEXT_IMPORT_MAX_BYTES = 15 * 1024 * 1024;
export const CONTEXT_IMPORT_JOB_POLL_INTERVAL_MS = 2000;

export const CONTEXT_IMPORT_JOB_ACTIVE_STATES = new Set(["NEW", "IN_PROGRESS"]);

const stripContentTypeForFormData = (data, headers) => {
  if (typeof FormData !== "undefined" && data instanceof FormData) {
    if (typeof headers?.delete === "function") {
      headers.delete("Content-Type");
    } else if (headers) {
      delete headers["Content-Type"];
    }
  }
  return data;
};

export function postContextImportValidate(formData) {
  return httpClient.post(buildContextImportPath("validate"), formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
}

export function postContextImportJob(formData) {
  return httpClient.post(`${CONTEXT_IMPORT_JOBS_BASE}?type=IMPORT`, formData, {
    transformRequest: [stripContentTypeForFormData],
    validateStatus: (status) =>
      status === 202 || (status >= 200 && status < 300),
  });
}

export function getContextImportJob(jobId) {
  return httpClient.get(
    `${CONTEXT_IMPORT_JOBS_BASE}/${encodeURIComponent(jobId)}`
  );
}
